/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 11/07/2024 | Lic. José Luis Aragón Cervantes  | Creación
 *      2       | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Protección anti doble click en acciones críticas
 *      3       | 18/09/2026 | Lic. José Luis Aragón Cervantes  | Botón reporte entradas/salidas por periodo
* ---------------------------------------------------------------------------------------
*/

import { Fragment, useEffect, useCallback } from "react";

import { IconButton, Tooltip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import DirectionsIcon from "@mui/icons-material/Directions";
import VerifiedIcon from "@mui/icons-material/Verified";
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import DensitySmallIcon from '@mui/icons-material/DensitySmall';
import RefreshIcon from "@mui/icons-material/Refresh";
import PrintIcon from '@mui/icons-material/Print';
import HomeIcon from '@mui/icons-material/Home';
import ContentCutIcon from '@mui/icons-material/ContentCut';
import PersonAddDisabledOutlinedIcon from '@mui/icons-material/PersonAddDisabledOutlined';
import LogoutIcon from '@mui/icons-material/Logout';
import InputIcon from '@mui/icons-material/Input';
import LoginIcon from '@mui/icons-material/Login';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import FaceIcon from '@mui/icons-material/Face';
import PinIcon from '@mui/icons-material/Pin';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import LockIcon from '@mui/icons-material/Lock';
import HttpsIcon from '@mui/icons-material/Https';
import SummarizeIcon from '@mui/icons-material/Summarize';
import PieChartIcon from '@mui/icons-material/PieChart';
import TableChartIcon from '@mui/icons-material/TableChart';
import InventoryIcon from '@mui/icons-material/Inventory';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';


import { useSesion } from "../../context/System/SesionContext";
import { useVentas } from "../../context/Ventas/VentasContext";
import { useDoubleClickPrevention } from "../../hooks/useDoubleClickPrevention";

export default function MnuCortesActions({ onGenerarReporteCorteGeneral, onGenerarReporte8020, onAbrirResumenVentasPeriodo, onAbrirInventarioExistente, onAbrirEntradasSalidasPeriodo, onRefrescar }) {
    const { getPermisoBoton, getNombreBoton, getStatusPath, parametrosCajaForm } = useSesion();
    const {
        handleClickRegresarMainDashboard,
        handleClickRefrescarDatosVenta,
        handleOpenModalLoginValidatorCortes,
        listaCortes,
        statusHerramientasAdministrativas = false,
        handleAbrirValidarAccesosHerramientas,
    } = useVentas();
    const { isProcessing, executeWithProtection } = useDoubleClickPrevention();

    return (
        <Fragment>
            <Tooltip title={"Home"}>
                <IconButton onClick={handleClickRegresarMainDashboard}>
                    <HomeIcon className="icon" /><p className="icon"> Salir</p>
                </IconButton>
            </Tooltip>
            {statusHerramientasAdministrativas && listaCortes.cabecero != null && (
                <Tooltip title="Generar cortes">
                    <IconButton onClick={() => executeWithProtection(handleOpenModalLoginValidatorCortes)} disabled={isProcessing}>
                        <VerifiedIcon className="icon" />
                    </IconButton>
                </Tooltip>
            )}
            {statusHerramientasAdministrativas && (
                <Tooltip title="Refrescar datos">
                    <IconButton onClick={onRefrescar || handleClickRefrescarDatosVenta}>
                        <RefreshIcon className="icon" />
                    </IconButton>
                </Tooltip>
            )}
            <Tooltip title={"Login acceso"}>
                <IconButton onClick={handleAbrirValidarAccesosHerramientas} >
                    {statusHerramientasAdministrativas ? <LockOpenIcon className="icon" /> : <LockIcon className="icon" />}
                    <p className="icon">Login admin</p>
                </IconButton>
            </Tooltip>
            {statusHerramientasAdministrativas && (
                <Tooltip title="Corte general sucursal">
                    <IconButton onClick={() => onGenerarReporteCorteGeneral && executeWithProtection(onGenerarReporteCorteGeneral)} disabled={isProcessing || !onGenerarReporteCorteGeneral}>
                        <SummarizeIcon className="icon" />
                    </IconButton>
                </Tooltip>
            )}
            {statusHerramientasAdministrativas && (
                <Tooltip title="Reporte + vendidos">
                    <IconButton onClick={() => onGenerarReporte8020 && executeWithProtection(onGenerarReporte8020)} disabled={isProcessing || !onGenerarReporte8020}>
                        <PieChartIcon className="icon" />
                    </IconButton>
                </Tooltip>
            )}
            {statusHerramientasAdministrativas && (
                <Tooltip title="Resumen ventas periodo">
                    <IconButton onClick={() => onAbrirResumenVentasPeriodo && executeWithProtection(onAbrirResumenVentasPeriodo)} disabled={isProcessing || !onAbrirResumenVentasPeriodo}>
                        <TableChartIcon className="icon" />
                    </IconButton>
                </Tooltip>
            )}
            {statusHerramientasAdministrativas && (
                <Tooltip title="Inventario existente">
                    <IconButton onClick={() => onAbrirInventarioExistente && executeWithProtection(onAbrirInventarioExistente)} disabled={isProcessing || !onAbrirInventarioExistente}>
                        <InventoryIcon className="icon" />
                    </IconButton>
                </Tooltip>
            )}
            {statusHerramientasAdministrativas && (
                <Tooltip title="Entradas / Salidas por periodo">
                    <IconButton onClick={() => onAbrirEntradasSalidasPeriodo && executeWithProtection(onAbrirEntradasSalidasPeriodo)} disabled={isProcessing || !onAbrirEntradasSalidasPeriodo}>
                        <SwapHorizIcon className="icon" />
                    </IconButton>
                </Tooltip>
            )}
        </Fragment>
    );
}
